import React from "react";
import DoughnutChart from "../../../../component/Controls/chart/doughnutChart";
import ChartFilter from "./chartFilter";
import Moment from 'moment';

function HirebaseDoughnutChart(props) {
  return (
    <>
      <div className="dashboard-section">
        <span className="dashboard-title">{props.title}</span>
        <ChartFilter
          showLocation={props.showLocation}
          locationOptionsValue={props.locationOptionsValue}
          onLocationChange={props.onLocationChange}

          onWeekClicked={(e) => props.onWeekClicked() && props.onWeekClicked(e)}
          onMonthClicked={(e) => props.onMonthClicked() && props.onMonthClicked(e)}
          onTodayClicked={(e) => props.onTodayClicked() && props.onTodayClicked(e)}

          startDate={props.startDate}
          endDate={props.endDate}
          onFilter={props.onFilter}

          actBtn={props.actBtn}
          title={props.actBtn === 'today' ? 'Date : ' + Moment(props.startDate).format('MM-DD-YYYY') : 'From : ' + Moment(props.startDate).format('MM-DD-YYYY') + ' To ' + Moment(props.endDate).format('MM-DD-YYYY')}
        />
      </div>
      <DoughnutChart
        legendChart={props.legendChart}
        labelsChart={props.labelsChart}
        valuesChart={props.valuesChart}
        backgroundColor={props.backgroundColor}
      />
    </>
  );
}

export default HirebaseDoughnutChart;